import { gql, useMutation } from '@apollo/client';
import { useCallback } from 'react';

type Props = {
    input?: {
        assetIDs?: number[];
        emitWebsocket?: boolean; // = false
        event: number;
        location: string;
    } ;
    eventToLink?: number | undefined;
} | { event: number; restart?: boolean };

type Args = {
assetIDs?: number[];
emitWebsocket?: boolean; // = false
event: number;
location: string;
} | { event: number; restart?: boolean } | { eventToLink: number };

const mutationMap = {
    streamSignal: gql`
    mutation PrepareStreamSignal($event: Float!) {
        prepareStreamSignal(event: $event)
    }
    `,
    startEvent: gql`
    mutation StartEvent($input: EventToActionInput!) {
        startEvent(eventToStart: $input)
    }
    `,
    stopEvent: gql`
    mutation StopEvent($input: EventToActionInput!) {
        stopEvent(eventToStop: $input)
    }
    `,
    forceStream: gql`
    mutation ForceStreamLink($eventToLink: Float!) {
       forceStreamLink(eventToLink: $eventToLink)
    }
    `
};

export type Commands = keyof typeof mutationMap;

export const useStream = (type: Commands): [
    (args: Args) => Promise<void>,
    { loading: boolean; error?: Error }
] => {
    const [mutate, { loading, error }] = useMutation<unknown, Props>(mutationMap[type], { });

    return [
        useCallback(async (args: Args) => {

            // const variables = { eventToLink: 'eventToLink' in args ? args.eventToLink : undefined}
            const variables = 'location' in args || 'eventToLink' in args
            ? {
                input: 'eventToLink' in args
                ?  undefined
                : {
                    location: args.location,
                    event: args.event,
                    emitWebsocket: false,
                    assetIDs: <number[]>[]
                },
                eventToLink: 'eventToLink' in args ? args.eventToLink : undefined
            } : { event: args.event };

            await mutate({variables: {...variables}});
        }, [mutate]),
        {
            loading,
            error
        }
    ];
};
